import angular from 'angular';

import component from './nativeTwinAd.component';

import NgAd from 'cars-ng-ad';

export default angular.module('vdp.shared.nativeTwinAd', [
    NgAd
])

.component('carsNativeTwinAd', component)

.name;
